<div class="container-fluid form-horizontal wl-event-setting-top-box-container highlight-box">
  <div *ngIf="!isLoading && event?.Version >= 3" class="wl-event-setting-top-box-inner">
    <div class="row">
      <div class="col-sm-5 col-sm-push-7 col-lg-4 col-lg-push-8 text-right">
        <div class="form-control-static">
          <wl-events-v4-copy [event]="event" title="{{ 'events.settings.copy-event-tooltip' | translate | titlecase }}"></wl-events-v4-copy>
          <button
            pButton
            type="button"
            class="atlas-btn atlas-btn-danger"
            icon="pi pi-trash"
            (click)="deleteClick()"
            [disabled]="userAccessLevel < 2"
            [tooltipPosition]="'top'"
            [pTooltip]="'events.settings.delete-event-tooltip' | translate | titlecase"
          ></button>
          <div [hidden]="!event?.EventId">
            <a
              [href]="
                tenantHttpsUrl +
                '/events/' +
                (event?.EventName | wlRegexReplace: '[\\W_-]+' : 'g' : '-') +
                '-' +
                event?.EventId +
                '/details'
              "
              target="_blank"
              >{{ 'events.detail.component.view-web-page' | translate }}</a
            >
          </div>

          <div class="wl-event-settings-event-button-space hidden-xs">
            <!-- adds space for the position absolute save button -->
          </div>
        </div>
      </div>
      <div class="col-sm-7 col-sm-pull-5 col-lg-8 col-lg-pull-4">
        <h2 *ngIf="event">
          {{ event?.EventName }} <span class="small">({{ event?.EventId }})</span>
        </h2>
        <div>
          <button
            app-add-button
            dataCy="btnEventSettingsNewRegistration"
            label="{{ 'events.settings.new-registration-label' | translate | titlecase }}"
            (click)="handleNewRegistrationClick()"
          ></button>
        </div>
        <p>
          {{ event?.StartDate | date: 'fullDate' }}<span *ngIf="event?.StartTime">, {{ event?.StartTime }}</span>
          <span *ngIf="(event?.StartDate | date: 'yMd') != (event?.EndDate | date: 'yMd')">
            - {{ event?.EndDate | date: 'fullDate' }}<span *ngIf="event?.EndTime">, {{ event?.EndTime }}</span></span
          >
          <span
            *ngIf="
              (event?.StartDate | date: 'yMd') == (event?.EndDate | date: 'yMd') && event?.EndTime && event?.StartTime != event?.EndTime
            "
          >
            - {{ event?.EndTime }}</span
          >
        </p>

        <address class="wl-event-settings-address-display">
          <div>{{ event?.Venue }}</div>
          <div>{{ event?.Address1 }} {{ event?.Address2 }}</div>
          <div>
            {{ event?.City }}{{ event?.City && event?.State ? ', ' : '' }}
            {{ event?.State }}
            {{ event?.Zip }}
          </div>
        </address>
      </div>
    </div>

    <div class="wl-event-setting-desktop-save-button hidden-xs">
      <wl-busy [show]="isSaving"></wl-busy>
      <button
        pButton
        type="button"
        class="atlas-btn atlas-btn-primary"
        [icon]="isSaving ? '' : 'pi pi-save'"
        [label]="(isSaving ? 'common.saving' : 'common.save') | translate | titlecase"
        (click)="saveEvent()"
        [disabled]="userAccessLevel < 2 || isSaving || isLoading"
      ></button>
    </div>
  </div>
  <div class="row" *ngIf="isLoading">
    <div class="col-xs-12">
      <div><wl-busy [show]="isLoading"></wl-busy> {{ 'common.loading' | translate | titlecase }}</div>
    </div>
  </div>
  <div class="row" *ngIf="!isLoading && event.EventId > 0 && event.Version < 3">
    <div class="col-xs-12">
      <p [hidden]="event?.Version != 0">{{ 'events.settings.edit-not-allowed-for-version-1-message' | translate }}</p>
      <p [hidden]="event?.Version != 2">{{ 'events.settings.edit-not-allowed-for-version-2-message' | translate }}</p>
    </div>
  </div>
  <div class="row" *ngIf="!isLoading && event.EventId <= 0">
    <div class="col-xs-12">
      <p [hidden]="event?.Version != 0">{{ 'events.settings.event-not-found-error-message' | translate | ucfirst }}</p>
    </div>
  </div>
</div>

<div [hidden]="event?.Version < 3" class="wl-event-setting-save-button-container pull-right visible-xs-block">
  <wl-busy [show]="isSaving"></wl-busy>
  <button
    pButton
    type="button"
    class="atlas-btn atlas-btn-primary"
    [disabled]="userAccessLevel < 2 || isSaving || isLoading"
    (click)="saveEvent()"
    [icon]="isSaving ? '' : 'pi pi-save'"
    [label]="(isSaving ? 'common.saving' : 'common.save') | translate | titlecase"
  ></button>
</div>
<wlx-tabs #tabsContainer [hidden]="event?.Version < 3">
  <wlx-tab #dashboardTab [title]="'events.dashboard.tab-title' | translate | titlecase">
    <wl-event-v4-dashboard
      #eventDashboardCtrl
      [tabContainer]="tabsContainer"
      [registrationTab]="registrationsTab"
      [registrationManagementCtrl]="registrationManagement"
      [event]="event"
    ></wl-event-v4-dashboard>
  </wlx-tab>
  <wlx-tab #registrationsTab [title]="'events.registration.management.tab-title' | translate | titlecase">
    <wl-event-v4-registration-management #registrationManagement [event]="event"></wl-event-v4-registration-management>
  </wlx-tab>
  <wlx-tab #attendeestab [title]="'events.attendees.management.tab-title' | translate | titlecase">
    <wl-event-v4-attendee-management #attendeeManagement [event]="event"></wl-event-v4-attendee-management>
  </wlx-tab>
  <wlx-tab #eventSettingsTab [title]="'events.settings.title' | translate | titlecase">
    <wlx-tab #generalSettingsTab [title]="'events.settings.general.title' | translate | titlecase">
      <ng-template wlLazyTabContent>
        <wl-event-v4-settings-general [event]="event" [(showEditor)]="eventSettingsTab.selected"></wl-event-v4-settings-general>
      </ng-template>
    </wlx-tab>
    <wlx-tab #eventItemsTab [title]="'events.settings.items.title' | translate | titlecase">
      <wl-event-v4-settings-items
        *ngIf="eventItemsTab.selected"
        (eventItemsListChange)="eventItemsListChanged()"
        [event]="event"
      ></wl-event-v4-settings-items>
    </wlx-tab>

    <wlx-tab [title]="'events.settings.registration.settings.title' | translate | titlecase" #registrationSettingsTab>
      <wl-event-v4-settings-registration-settings
        [event]="event"
        (onValidChange)="registrationSettingsTab.valid = $event"
        [(showEditor)]="registrationSettingsTab.selected"
      ></wl-event-v4-settings-registration-settings>
    </wlx-tab>
    <wlx-tab [title]="'events.settings.notifications.title' | translate | titlecase">
      <ng-template wlLazyTabContent>
        <wl-event-v4-settings-notifications [event]="event"></wl-event-v4-settings-notifications>
      </ng-template>
    </wlx-tab>
    <wlx-tab #eventRegistrationFieldsTab [title]="'events.settings.registration-fields.title' | translate | titlecase">
      <wl-event-v4-settings-registration-fields
        *ngIf="eventRegistrationFieldsTab.selected"
        [event]="event"
      ></wl-event-v4-settings-registration-fields>
    </wlx-tab>
    <wlx-tab #eventPromoCodesTab title="Promo Codes">
      <wl-event-v4-settings-promo-codes
        *ngIf="eventPromoCodesTab.selected"
        [eventId]="event.EventId"
        [event]="event"
      ></wl-event-v4-settings-promo-codes>
    </wlx-tab>
    <wlx-tab #eventBenefitsTab [enabled]="hasEventBenefits" [title]="'events.settings.benefits.title' | translate | titlecase">
      <wl-event-v4-settings-benefits *ngIf="eventBenefitsTab.selected" [event]="event"></wl-event-v4-settings-benefits>
    </wlx-tab>
    <wlx-tab #eventSponsorsTab [title]="'events.settings.sponsors.title' | translate | titlecase">
      <wl-event-v4-settings-sponsors *ngIf="eventSponsorsTab.selected"></wl-event-v4-settings-sponsors>
    </wlx-tab>
  </wlx-tab>
</wlx-tabs>

<p-dialog
  modal="true"
  #unsavedChangesModal
  [(visible)]="showModal"
  [closable]="false"
  styleClass="atlas-dialog-s"
  [focusOnShow]="false"
  [contentStyle]="{ 'max-height': '75vh' }"
>
  {{ 'events.settings.unsaved-changes-message' | translate }}
  <ng-template pTemplate="footer">
    <wl-busy *ngIf="isSaving" [show]="isSaving"></wl-busy>
    <button
      pButton
      type="button"
      class="atlas-btn atlas-btn-primary"
      (click)="handleUnsavedChangesModalSaveClick()"
      [disabled]="isSaving"
      [icon]="isSaving ? '' : 'pi pi-save'"
      [label]="(isSaving ? 'common.saving' : 'common.save') | translate | titlecase"
    ></button>
    <cancel-button
      [label]="'common.cancel' | translate | titlecase"
      [disabled]="isSaving"
      (onClick)="handleUnsavedChangesModalCancelClick()"
    >
    </cancel-button>
    <cancel-button
      [label]="'common.no' | translate | titlecase"
      styleClass="atlas-btn-default"
      [disabled]="isSaving"
      (onClick)="handleUnsavedChangesModalNoClick()"
    >
    </cancel-button>
  </ng-template>
</p-dialog>

<div>
  <div>
    <wl-event-v4-registration-wizard
      (onRegistrationSaved)="handleRegistrationSaved()"
      #registrationWizardModal
    ></wl-event-v4-registration-wizard>
  </div>
</div>

<p-confirmDialog
  #cd
  key="invalidCustomFieldsCD"
  header="{{ 'common.warning' | translate | ucfirst }}"
  icon="pi pi-exclamation-triangle"
  styleClass="atlas-dialog-s"
>
  <p-footer>
    <button pButton type="button" class="atlas-btn atlas-btn-secondary mr-10" (click)="cd.onReject()">
      {{ 'common.cancel' | translate | uppercase }}
    </button>
  </p-footer>
</p-confirmDialog>
